import { render, staticRenderFns } from "./TextLongField.vue?vue&type=template&id=070da4a8&scoped=true&"
import script from "./TextLongField.vue?vue&type=script&lang=js&"
export * from "./TextLongField.vue?vue&type=script&lang=js&"
import style0 from "./TextLongField.vue?vue&type=style&index=0&id=070da4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070da4a8",
  null
  
)

export default component.exports